import React, { useRef, useState } from 'react'
import { IntersectionalityFilterRef } from '@diversioteam/diversio-ds'
import { useParams, useHistory, Redirect } from 'react-router-dom'

import { FiltersContextController } from 'context/filters/filtersContextController/FiltersContextController'
import { useViewTracking } from 'hooks/useViewTracking'
import { useVersion } from 'hooks/useVersion'
import { useUserInformation } from 'hooks/useUserInformation'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'

import { Data } from './Data'
import { FilterPane } from './FilterPane'
import { InclusionParams } from './Inclusion.types'
import * as S from './inclusion.styles'

export const Inclusion = () => {
    useViewTracking('Analyze v2 - Inclusion')

    const { tab } = useParams<InclusionParams>()
    const versionsContext = useVersion()
    const { enableDebugMode } = useUserInformation()

    const [selectedTab, setSelectedTab] = useState<InclusionParams['tab']>(tab || 'target_groups')
    const [selectedTabType, setSelectedTabType] = useState<string>('')
    const history = useHistory()
    const ref = useRef<IntersectionalityFilterRef | null>(null)

    const handleOnTabChange = (to: InclusionParams['tab'], tabType: string) => {
        setSelectedTab(to)
        setSelectedTabType(tabType)

        if (selectedTab !== to) {
            return history.replace(`/analyze2/inclusion/${to}${location.search}`)
        }
    }

    const isV2Enabled = versionsContext?.version === versionsContext?.AVAILABLE_VERSIONS.v2

    if (!isV2Enabled && !enableDebugMode) {
        return <Redirect to={generateCompanyURI('/analyze/inclusion')} />
    }

    return (
        <FiltersContextController>
            <S.Inclusion>
                <S.Content>
                    <S.LeftBox>
                        <FilterPane
                            handleOnTabChange={handleOnTabChange}
                            selectedTab={selectedTab}
                            selectedTabType={selectedTabType}
                            ref={ref}
                        />
                    </S.LeftBox>

                    <S.RightBox>
                        <Data selectedTab={selectedTab} selectedTabType={selectedTabType} ref={ref} />
                    </S.RightBox>
                </S.Content>
            </S.Inclusion>
        </FiltersContextController>
    )
}
